import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { DEFAULT_BULK_ACTIONS_EDIT_TASKS_MODAL_KEY } from '../../../constants/modalKeys';
import { useBulkActionsHasError } from '../../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../../hooks/useBulkActionsIsLoading';
import { useBulkActionsOpenModal } from '../../../hooks/useBulkActionsOpenModal';
import { useBulkActionsPermissionsForCurrentSelection } from '../../../hooks/useBulkActionsPermissionsForCurrentSelection';
import { BaseBulkActionButton } from '../BaseBulkActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const EditTasks = ({
  modalProps
}) => {
  const openModal = useBulkActionsOpenModal();
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const canBulkEditTasks = useBulkActionsPermissionsForCurrentSelection('canEdit');
  const disabled = isLoading || hasError || !canBulkEditTasks;
  const onClick = useCallback(() => {
    openModal({
      modalKey: DEFAULT_BULK_ACTIONS_EDIT_TASKS_MODAL_KEY,
      props: modalProps
    });
  }, [modalProps, openModal]);
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    "data-test-id": "bulk-actions-edit-tasks",
    disabled: disabled,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.tasks.generic"
    }),
    icon: "edit",
    isLoading: isLoading,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonLabels.tasks.edit"
    })
  });
};